import { createEmptyFormErrors } from '@/store/slices/components/eventTypes/formErrors';
import { validateClosures } from '../FinalizationReport/utils/validateClosures';

export const NAME_ERROR = {
  MISSING: 'missingName',
  DUPLICATE_NAME: 'duplicateName',
};

export const normalizeEventTypeName = (name) =>
  name?.trim().toLowerCase() ?? '';

export const isEventTypeNameDuplicated = (
  name,
  events = [],
  currentId = null
) => {
  const normalized = normalizeEventTypeName(name);

  if (!normalized) return false;

  return events.some(
    (event) =>
      normalizeEventTypeName(event.name) === normalized &&
      String(event.id) !== String(currentId)
  );
};

export const getDuplicateEventTypeNameError = (
  name,
  events = [],
  currentId = null
) =>
  isEventTypeNameDuplicated(name, events, currentId)
    ? NAME_ERROR.DUPLICATE_NAME
    : null;

export const getNameValidationError = (
  name,
  { events = [], currentId = null } = {}
) => {
  if (!name?.trim()) return NAME_ERROR.MISSING;

  return getDuplicateEventTypeNameError(name, events, currentId);
};

export const validateEventTypeForm = (form, { events = [] } = {}) => {
  const errors = createEmptyFormErrors();
  let isValid = true;

  const nameError = getNameValidationError(form.name, {
    events,
    currentId: form.id,
  });

  if (nameError) {
    errors.name = nameError;
    isValid = false;
  }

  const closuresResult = validateClosures(form.closures);

  if (!closuresResult.isValid) {
    errors.closures = closuresResult.errors;
    isValid = false;
  }

  // TODO: notifyUsers, notifyContacts, etc.

  return {
    isValid,
    errors,
    validClosures: closuresResult.validClosures,
  };
};
